import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function fetchSavedFitlerReducer(state = initialState.savedFilters, action) {
  switch (action.type) {
    case types.SET_SAVED_FILTER_LIST_SUCCESS: {
      return Object.assign({}, state, {
        filters: action.filters,
      });
    }
    default:
      return state;
  }
}
